<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig"
    :class="getClassName"
  >
    <appPageOptionAttributes
      v-for="pageOptionAttributes in getProductPageOptionValues"
      :key="pageOptionAttributes.value"
      :propsData="pageOptionAttributes"
      :ppcode="ppcode"
      :code="code"
    >
    </appPageOptionAttributes>
    <appInputCustomFormat
      v-if="code == 'format'"
      :nrItems="getProductPageOptionValues.length"
      :ppcode="ppcode"
    >
    </appInputCustomFormat>
  </component>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useWebproductStore } from "@/stores/modules/webproduct";

export default {
  computed: {
    ...mapState(useWebproductStore, [
      "getActiveProductPageOptions",
      "getProductPageOptionsForCode"
    ]),
    getProductPageOptionValues: function () {
      if (this.ppcode) {
        const ppData = this.getProductPageOptionsForCode({ code: this.ppcode });
        if (ppData[this.code]) {
          return ppData[this.code].values;
        }
        return [];
      }
      if (this.getActiveProductPageOptions[this.code]) {
        return this.getActiveProductPageOptions[this.code].values;
      }
      return [];
    }
  },
  props: ["propsData", "code", "hideContainer", "ppcode"]
};
</script>
